module.exports = __webpack_public_path__ + "static/media/wiser-notifly.a5fba076.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/wiser-notifly.png
// module id = 971
// module chunks = 0